import React from 'react';

// Styles & Assets
import styles from './ToolbarCases.module.css';
import { RiFilterFill } from 'react-icons/ri';
import { MdEdit } from 'react-icons/md';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import Toolbar from '../../UI/Toolbar/Toolbar';
import Searchbar from '../../UI/Searchbar/Searchbar';
import ButtonToolbar from '../../UI/ButtonToolbar/ButtonToolbar';
import FilterCasesDialog from '../FilterCasesDialog/FilterCasesDialog';
import EditCasesColumnsDialog from '../EditCasesColumnsDialog/EditCasesColumnsDialog';

// Interfaces
import { FiltersPatientCases, PatientCasesFiltersDispatch } from '../../../reducers/patient-cases-reducer';
import { Moment } from 'moment';
import { CaseHistory } from '../../../interfaces/Patient';
import { Column } from '../../../interfaces/Columns';
interface Props {
    totalFiltered: number
    totalCases: number
    columns: Column<CaseHistory>[]
    filtersCases: FiltersPatientCases
    dispatchFilters: React.Dispatch<PatientCasesFiltersDispatch>
    changeVisibility: (id: number) => void
}

const ToolbarCases: React.FC<Props> = ({ totalFiltered, totalCases, columns, filtersCases, dispatchFilters, changeVisibility }) => {

    const { t } = useTranslation();

    const { entryDateFrom, exitDateTo, environmentID } = filtersCases;

    const handleChangeSearch = (value: React.ChangeEvent<HTMLInputElement>) => {
        dispatchFilters({ type: 'CHANGE_TEXT', text: value.target.value });
    }

    const handleConfirm = (environment: number | null, startDate: Moment | null, endDate: Moment | null) => {
        dispatchFilters({ type: 'CHANGE_ENVIRONMENT_ID', environmentID: environment });
        dispatchFilters({ type: 'CHANGE_ENTRY_DATE', date: startDate });
        dispatchFilters({ type: 'CHANGE_EXIT_DATE', date: endDate });
    }


    return (
        <Toolbar text={t('patients')} link='/home/patients'>
            <div className={styles.flexToolbar}>
                <Searchbar
                    handleChange={handleChangeSearch}
                />
                <ButtonToolbar
                    icon={<RiFilterFill />}
                    label={t('filter') + ` (${totalFiltered}/${totalCases})`}
                    defaultFilterActive={environmentID !== null || entryDateFrom !== null || exitDateTo !== null}
                >
                    <FilterCasesDialog
                        currentEnvironmentID={environmentID}
                        currentStartDate={entryDateFrom}
                        currentEndDate={exitDateTo}
                        onConfirm={handleConfirm}
                    />
                </ButtonToolbar>
                <ButtonToolbar
                    icon={<MdEdit />}
                    label={t('custom_columns')}
                >
                    <EditCasesColumnsDialog
                        columns={columns}
                        changeVisibility={changeVisibility}
                    />
                </ButtonToolbar>
            </div>
        </Toolbar>
    );
};

export default ToolbarCases;